/**
 * Imperative bridge so Adaptive Card custom elements (separate React roots) can run
 * search against host context (tab/user/tenant) owned by AdaptiveCardProxy.
 */
let searchHandler = null;

/**
 * @param {((searchText: string, dataSet: string, data?: object) => Promise<unknown>|unknown) | null} fn
 */
export function setAdaptiveCardSearch(fn) {
    searchHandler = fn;
}

export function clearAdaptiveCardSearch() {
    searchHandler = null;
}

/**
 * @param {string} searchText
 * @param {string} dataSet
 * @param {object} [data]
 * @returns {Promise<unknown[]>}
 */
export async function adaptiveCardSearch(searchText, dataSet, data = {}) {
    if (!searchHandler) return [];
    const raw = await searchHandler(searchText, dataSet, data);
    return raw;
}
